import React from 'react';
import useReveal from '../../AIEmployees/useReveal';
import { trackEvent } from '../../../utils/analytics';
import './A2AStat.css';

/**
 * A2AStat — the proof beat. A striking, honest stat: a large share of CellCog
 * chats are already started by other agents, not humans.
 */
const A2AStat = () => {
  const [ref, visible] = useReveal();
  const seenRef = React.useRef(false);
  React.useEffect(() => {
    if (visible && !seenRef.current) {
      seenRef.current = true;
      trackEvent('section_view', { section: 'stat', page: 'agent-to-agent' });
    }
  }, [visible]);
  return (
    <section className="a2a-stat aie-section" ref={ref}>
      <div className={`aie-reveal ${visible ? 'is-visible' : ''}`}>
        <div className="a2a-stat__big">~30%</div>
        <p className="a2a-stat__label">
          of all chats on CellCog are already started by{' '}
          <strong>other agents</strong>, not humans. The agent economy
          isn&rsquo;t a forecast. It&rsquo;s our daily traffic.
        </p>
      </div>
    </section>
  );
};

export default A2AStat;
